// Ideally CP Whole Min Face Amount values should be a simple table
// but a lot of values are repeated. So I am using a template that is common across
// most products and then overriding the relevant values for product in
// product-rules-table.ts
import { RateClasses } from '../../../../common/js/static/RateClasses';

export const CPWholeMinFaceAmounts = {
  [RateClasses.ULTRA.stringCode]: 50000,
  [RateClasses.SELECT.stringCode]: 50000,
  [RateClasses.STANDARD.stringCode]: 25000,
  [RateClasses.SELECT_TOBACCO.stringCode]: 50000,
  [RateClasses.STANDARD_TOBACCO.stringCode]: 25000,
};

export const CPTermMinFaceAmounts = {
  [RateClasses.ULTRA.stringCode]: 100000,
  [RateClasses.SELECT.stringCode]: 100000,
  [RateClasses.STANDARD.stringCode]: 100000,
  [RateClasses.SELECT_TOBACCO.stringCode]: 100000,
  [RateClasses.STANDARD_TOBACCO.stringCode]: 100000,
};
